import React from "react"

import "./LoadingSpinner.scss"

const LoadingSpinner: React.FC<{type: "onLight" | "onDark"}> = ({ type }) => {
  return <div className={`neo__loadingSpinner neo__loadingSpinner--${type}`} />
}

export default LoadingSpinner
